import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "TextSelection"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21 20.25H15.75C14.5074 20.25 13.5 19.2426 13.5 18V16.5C13.5 15.2574 14.5074 14.25 15.75 14.25H19.5V12.75C19.5 12.3358 19.1642 12 18.75 12H14.25V10.5H18.75C19.9926 10.5 21 11.5074 21 12.75V20.25ZM15.75 15.75C15.3358 15.75 15 16.0858 15 16.5V18C15 18.4142 15.3358 18.75 15.75 18.75H19.5V15.75H15.75ZM9.75 5.25H12V3.75H9.75C8.88595 3.75488 8.06595 4.13207 7.5 4.785C6.93405 4.13207 6.11405 3.75488 5.25 3.75H3V5.25H5.25C6.07843 5.25 6.75 5.92157 6.75 6.75V10.5H3.75V12H6.75V17.25C6.75 18.0784 6.07843 18.75 5.25 18.75H3V20.25H5.25C6.11405 20.2451 6.93405 19.8679 7.5 19.215C8.06595 19.8679 8.88595 20.2451 9.75 20.25H12V18.75H9.75C8.92157 18.75 8.25 18.0784 8.25 17.25V12H11.25V10.5H8.25V6.75C8.25 5.92157 8.92157 5.25 9.75 5.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/TextSelection.vue"]]);
